import React, { useEffect } from 'react';

import { CurrentDocumentInvalidatedV1, PdpPageEvents } from '@vp/pdp-events';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { ToastProvider } from '../components/StickyToast';

export const useCurrentDocumentInvalidated: ToastProvider = (setToast) => {
  const { t } = useLocalizations();
  useEffect(() => {
    const handleDocumentInvalidated = (event: CurrentDocumentInvalidatedV1) => {
      if (event.reason === 'IncompatibleSelection')
        setToast({
          skin: 'warning',
          body: <>{t('error-document-url')}</>,
        });
      else if (event.reason === 'ErrorGeneratingScenes') {
        setToast({
          skin: 'warning',
          body: <>{t('template-error-toast')}</>,
        });
      }
    };

    return PdpPageEvents.listenToCurrentDocumentInvalidatedEventV1(handleDocumentInvalidated);
  }, []);
};
